import React from "react";
import Translator from "Languages/Utility/Translator"

export default function ToggleButton({ props }) {
  // console.log(props);
  // props.onChange(props.name, props.value);
  const onClick = (item) => {
    props.onChange(props.name, null, item)
  }
  return (
    <div className="inner-toggle-button">
      {
        props.items.map(item => {
          return(
            <div
              className={`inner-item-button ${props.value.value === item.value ? 'active' : 'deactive'}`}
              onClick={() => onClick(item)}
            >
              <Translator id={item.key}/>
            </div>
          )
        })
      }
    </div>
  );
}
